import type { Client, RequestContext } from "../client";
import type { TaskResource } from "../resources";
export type TelemetryTypes = "performance" | "features";
type DownloadParams = {
    type: TelemetryTypes;
};
type SendParams = {
    type: TelemetryTypes;
};
type RecordPortalOperationTelemetryCommand = {
    source: string;
    operation: string;
    resultsDiscarded: boolean;
    isVersionControlled?: boolean;
    duration: number;
};
export class TelemetryRepository {
    protected client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    download(params: DownloadParams): Promise<void> {
        return this.client.get(this.requestContext, this.client.getLink("TelemetryDownload"), params);
    }
    send(params: SendParams): Promise<void> {
        return this.client.get(this.requestContext, this.client.getLink("TelemetrySend"), params);
    }
    getLatestTelemetryTask(): Promise<TaskResource> {
        const link = this.client.getLink("TelemetryLastTask");
        return this.client.get(this.requestContext, link);
    }
    recordLoadDuration(command: RecordPortalOperationTelemetryCommand) {
        return this.client.post(this.requestContext, "~/bff/telemetry/recordPortalOperation", command);
    }
}
